import React from 'react';
import UploadContent from './UploadContent';
import TrackingContent from './TrackingContent';

const SubmissionContent = ({ submenuKey }) => {
  return (
    <div className="animate-fadein">
      {submenuKey === 'upload' && <UploadContent />}
      {submenuKey === 'tracking' && <TrackingContent />}
    </div>
  );
};

export default SubmissionContent; 